export enum NotificationFrequencyEnum {
  HOURLY = 'HOURLY',
  DAILY = 'DAILY',
}


